import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContenedorComponent } from '../contenedor/contenedor.component';
import { authGuardSubmodule } from '../../auth/auth.guard';

import { MatrizEventosComponent } from './matriz-eventos/matriz-eventos.component';
import { AnalisisEventosComponent } from './analisis-eventos/analisis-eventos.component';
import { AnalisisCombinadoComponent } from './analisis-combinado/analisis-combinado.component';
import { MapaCalorComponent } from './mapa-calor/mapa-calor.component';

const routes: Routes = [{
  path: 'app/operative',
  component: ContenedorComponent,
  children: [
    {path: 'matriz-eventos', component: MatrizEventosComponent, canActivate: [authGuardSubmodule]},
    {path: 'analisis-eventos', component: AnalisisEventosComponent, canActivate: [authGuardSubmodule]},
    {path: 'analisis-combinado', component: AnalisisCombinadoComponent, canActivate: [authGuardSubmodule]},
    {path: 'mapa-calor', component: MapaCalorComponent, canActivate: [authGuardSubmodule]},
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OperativoRoutingModule { }
